import wrapped from './window_wrapper';
import qs from 'qs';

interface CoreLinkLocation {
  // The ID of the dom element we will scroll to
  anchor?: string;

  // Query params for the request
  query?: object;

  // Pathname with or without ORIGIN
  pathname?: string;
}

export type ToTarget = string | CoreLinkLocation;

interface HistoryURL {
  origin?: string;
  pathname?: string;
  query?: object;
  hash?: string;
}

export function isActive(to: HistoryURL, current: Partial<Location>) {
  return (
    to.pathname === current.pathname &&
    to.hash === current.hash
  );
}

export function serializeURL(url: HistoryURL): string | undefined {
  if (!url) {
    return;
  }

  const { origin, pathname, query, hash } = url;

  let search = '';

  if (query && Object.keys(query).length) {
    search = `?${qs.stringify(query)}`;
  }

  const href = `${origin || ''}${pathname || ''}${search}${hash || ''}`;
  if (href === '') {
    return;
  }

  return href;
}

export function parseURL(to: ToTarget): HistoryURL {
  if (!to) {
    return {};
  }

  // Yes this is set to the string, null in production while in RRE.
  let origin;
  if (!wrapped.location.origin || wrapped.location.origin === 'null') {
    origin = WEB_HOST;
  } else {
    origin = wrapped.location.origin;
  }

  if (typeof to === 'string') {
    let u;

    // Allow relative and absolute URLs to be used, but respect a different domain
    if (to.match(/^http/)) {
      u = new URL(to);
    } else {
      u = new URL(to, origin);
    }

    return {
      origin: u.origin,
      pathname: u.pathname,
      query: qs.parse(u.search, { ignoreQueryPrefix: true }),
      hash: u.hash,
    };
  }

  let { pathname } = to;
  if (!pathname) {
    pathname = wrapped.location.pathname;
  }

  let hash;
  if (to.anchor) {
    hash = `#${to.anchor}`;
  }

  return {
    origin,
    pathname,
    hash,
    query: to.query,
  };
}
